import * as actions from "./actionsTypes";

const initialData = {
  loader: false,
  saveLoader: false,
  tasks: [],
  tasksLength: 0,
  tasksError: "",
  formError: "",
};

export default function tasksReducer(state = initialData, action) {
  switch (action.type) {
    case actions.TASKS_LOADER:
      return { ...state, loader: action.payload };
    case actions.TASKS_SAVE_LOADER:
      return { ...state, saveLoader: action.payload };
    case actions.GET_TASKS:
      return {
        ...state,
        tasks: action.payload.tasks,
        tasksLength: action.payload.tasksLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.TASKS_FAIL:
      return { ...state, tasksError: action.payload };
    default:
      return state;
  }
}
